import {memo} from 'react';
import { FormControl, TextareaAutosize, FormLabel } from '@material-ui/core';
import { useStyles } from '../Styles/styles';


function DefendantDidThen(props) {
  const classes = useStyles();
  return ( 
    <FormControl variant="standard" fullWidth className={props.formControl}>
    <FormLabel component="label">{"Defendant\xa0Did\xa0Then"}</FormLabel>
    <TextareaAutosize
      className={props.nightMode ? classes.textAreaDark : classes.textAreaLight}
      disabled={props.memoizedDisabled}
      data-cy="defendantActions"
      style={{ fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "1rem", width: '100%' }}
      margin='dense'
      id="defendantActions-id"
      // value={props.defendantActions || ""}
      // onChange={(e) => props.handleChange(e, false)}
      // onBlur={(e) => props.handleChange(e, true)}
     
      defaultValue={props.defendantActions || ""}
      onBlur={(e) => props.handleChange(e, true)}
      
      name='defendantActions'
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.target.blur();
        }
      }}
    />
  </FormControl>
   );
}
 
export default memo(DefendantDidThen);